export default __webpack_public_path__ + "static/media/pexels-photo-6098047.173ce27b.jpeg";